import { render, staticRenderFns } from "./AuditItemRow.vue?vue&type=template&id=5224b870&"
import script from "./AuditItemRow.vue?vue&type=script&lang=js&"
export * from "./AuditItemRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports